import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const url: string = state.url;
    const isAuthenticated: boolean = this.authService.isAuthenticated();

    if (!isAuthenticated) {
      this.authService.removeAuthentication();
      this.authService.setRedirectUrl(url);
      this.router.navigateByUrl('/auth');
      return false;
    } else {
      return true;
    }
  }
}
